import { render, staticRenderFns } from "./AdminAssessmentReport.vue?vue&type=template&id=ef7e36e4&scoped=true"
import script from "./AdminAssessmentReport.vue?vue&type=script&lang=js"
export * from "./AdminAssessmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7e36e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef7e36e4')) {
      api.createRecord('ef7e36e4', component.options)
    } else {
      api.reload('ef7e36e4', component.options)
    }
    module.hot.accept("./AdminAssessmentReport.vue?vue&type=template&id=ef7e36e4&scoped=true", function () {
      api.rerender('ef7e36e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_estrategy/AdminAssessmentReport.vue"
export default component.exports